import React from 'react'

function TextInput(props) {
    let { 
        labelName, inputChangeHandler, name, textName, inputValue,
        error, id, validate, htmlFOr, placeholder, type, passwordRef
     } = props
  return (
    <>
        <input
            textname={textName}
            name={name}
            onChange={inputChangeHandler}
            value={inputValue}
            placeholder={placeholder}
            type={type}
            className={`form-control ${error.staff_id && 'is-invalid'}`}
            id={id} required=""
            autoComplete=''
            ref={passwordRef}
        /> 
    </>
  )
}

export default TextInput